import {createContext} from 'react'

const TipoValeContext = createContext()

export default TipoValeContext